export default () => ({
	path: 'privacy',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./container.js').default;
					cb(null, component);
				},
				'Privacy',
			),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/Privacy/index.js